export default __webpack_public_path__ + "static/media/icon_bandstyle_Flat.a7fd5c65.png";